/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { MdError, MdOutlineCloudUpload } from "react-icons/md";
import { FaEye, FaRegFile } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import logo from "../../images/Coloured.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDownloadURL, ref } from "firebase/storage";
import { uploadBytesResumable } from "firebase/storage";
import { db, storage } from "../../config/firebase-config";
import { toast } from "react-toastify";
import { getFunctions, httpsCallable } from "firebase/functions";
import LinearProgress from "@mui/material/LinearProgress";
import { useDispatch, useSelector } from "react-redux";
import { TRANSCRIPT_STATUS } from "../../redux/constants/appPayloadTypes";
// import { getTranscriptLink } from "../../utils/getTranscriptLink";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import TranscriptModal from "../TranscriptModal/TranscriptModal";
import cube from "../../images/cube.gif";
import { getTranscription } from "../../functions";

const Process = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const functions = getFunctions();

  const getParticipants = httpsCallable(functions, "getParticipants");
  // const getTranscriptContent = httpsCallable(functions, "getTranscriptContent");
  // const getTranscriptLink = httpsCallable(functions, "getTranscriptLink");
  const { transcript_status } = useSelector((state) => state.appReducer);
  const { uid } = useSelector((state) => state.authReducer);
  const { userData } = useSelector((state) => state.authReducer);
  const [languagesArray, setLanguagesArray] = useState([]);
  const languageOptions = {
    english: "English",
    arabic: "Arabic",
    dutch: "Dutch",
    french: "French",
    german: "German",
    hindi: "Hindi",
    italian: "Italian",
    japanese: "Japanese",
    portuguese: "Portuguese",
    spanish: "Spanish",
    tamil: "Tamil",
  };
  const fileRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState();
  const [audioFileType, setAudioFileType] = useState();
  const [url, seturl] = useState();
  const [percent, setPercent] = useState(0);
  const [participants, setParticipants] = useState();
  const [participant, setParticipant] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [fileId, setFileId] = useState();
  const [fileContent, setFileContent] = useState();
  const [reprocessCheck, setReprocessCheck] = useState(false);
  const [fileType, setFileType] = useState("2");
  // 1 for transcript
  // 2 for audio
  const [transcriptLinkRec, setTranscriptLinkRec] = useState(false);
  //check if transcript link has been received from processed audio file, prevents infinite loop of the useEffect that has url, filename as dependency
  const [audioNotAllowed, setAudioNotAllowed] = useState(false);
  const [firebaseUrl, setFirebaseUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("english");
  const [audioDuration, setAudioDuration] = useState(0);
  const [transcriptModal, setTranscriptModal] = useState(false);
  const [transcriptVtt, setTranscriptVtt] = useState();

  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get("type") === "1") setFileType("2");
    if (searchParams.get("type") === "2") setFileType("2");
  }, []);

  useEffect(() => {
    if (transcript_status === TRANSCRIPT_STATUS.PROCESSING) {
      setDataLoading(true);
    } else setDataLoading(false);
    if (transcript_status === TRANSCRIPT_STATUS.PROCESSED) {
      setFile(null);
      fileRef.current.value = null;
      setParticipant(null);
      setParticipants(null);
      setFileContent(null);
      setFileId(null);
      setFileName(null);
      setFileType("2");
      setFirebaseUrl(null);
      setLoading(false);
      setPercent(0);
      setReprocessCheck(false);
      seturl(null);
      setTranscriptLinkRec(false);
      setAudioNotAllowed(false);
      setAudioDuration(0);
      setTranscriptVtt(null);
    }
  }, [transcript_status]);

  useEffect(() => {
    if (!localStorage.getItem("@auth")) {
      navigate("/signup");
    }
  }, []);

  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  //if the file id is new, indicates that this file has never been processed, so data is added to firebase

  //uploads the transcript/audio if logged in in users/<uid> otherwise tempFiles
  //using states url and firebaseUrl because url will be replaced by url from getTranscriptLink function in case of audio uploads
  const uploadTranscript = () => {
    toast("Uploading...", { type: "info" });
    if (uid) {
      if (file) {
        // let timeStamp = (new Date()).getMilliseconds()
        setFileName(`${file.name}`);
        const storageRef = ref(storage, `users/${uid}/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setPercent(progress);
          },
          (err) => {
            console.log(err);
          },
          () => {
            // download url
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
              setPercent(100);
              seturl(url);
              setFirebaseUrl(url);
            });
          }
        );
      }
    }
    //deprecated deprecated deprecated, THIS IS NEVER REALLY CALLED BECAUSE CURRENT FLOW DOES NOT ALLOW NON-LOGGED-IN USER TO ACCESS ANY PAGE, EXCEPT LOGIN SIGNUP
    else {
      if (file) {
        let timeStamp = new Date().getMilliseconds();
        setFileName(`${file?.name}___${timeStamp}`);
        const storageRef = ref(
          storage,
          `tempFiles/${file?.name}___${timeStamp}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setPercent(progress);
          },
          (err) => {
            console.log(err);
          },
          () => {
            // download url
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
              setPercent(100);
              seturl(url);
              setFirebaseUrl(url);
            });
          }
        );
      }
    }
  };

  //as soon as we receive file we need to upload it
  //if it is transcript, fileType=1, get transcript content and simply upload
  //if it is audio, fileType=2, setAudioFileType and check duration < 30mins, size < 200mb
  //if audio exceeds duration or size setAudioNotAllowed(true), otherwise setAudioDuration and simply upload
  useEffect(() => {
    if (file && fileType === "1") {
      // console.log("reading transcript file", file);
      let fileToRead = document.getElementById("selectedFile").files[0];
      let reader = new FileReader();
      reader.onloadend = function (e) {
        let content = reader.result;
        setFileContent(content);
        // console.log("file read: ", content);
      };
      reader.readAsText(fileToRead);
      uploadTranscript();
    } else if (file && fileType === "2") {
      var audio = document.createElement("audio");
      let fileToRead = document.getElementById("selectedFile").files[0];
      let filename = fileToRead?.name;
      let fileID = `${filename}_${Date.now()}`;
      let size = fileToRead?.size;
      if (fileToRead.name.includes(".mp3")) setAudioFileType("mp3");
      else if (fileToRead.name.includes(".mp4")) setAudioFileType("mp4");
      else if (fileToRead.name.includes(".m4a")) setAudioFileType("m4a");
      else if (fileToRead.name.includes(".wav")) setAudioFileType("wav");
      let reader = new FileReader();
      reader.onloadend = function (e) {
        audio.src = e.target.result;
        // console.log(size," bytes"," from file",fileToRead);
        audio.addEventListener(
          "loadedmetadata",
          function () {
            var duration = audio.duration; //gives duration in seconds
            // console.log(duration, "duration")
            if (
              (duration > 300 * 60 || size > 1000 * 1024 * 1024) &&
              (userData ? (userData?.superUser ? false : true) : true)
            ) {
              setAudioNotAllowed(true);
            } else {
              // setFileName(filename);
              setFileId(fileID);
              setAudioNotAllowed(false);
              uploadTranscript();
              setAudioDuration(duration);
            }
          },
          false
        );
        // console.log("file read: ", content);
      };
      reader.readAsDataURL(fileToRead);
    }
  }, [file]);

  //after upcoming we get url and filename
  // for transcript, just call getParticipants and get participants and fileId
  // for audio, call getTranscriptLink for performing transcription(english/mutlilingual)
  // then fetch participants, fileId as usual

  //READ HERE FOR NEW API CHANGES OF UPLOAD AUDIO

  const extractParticipants = (transcript) => {
    console.log("trans: ", transcript);
    const participants = new Set();
    const lines = transcript.split("\n");

    for (const line of lines) {
      const match = line.match(/<v ([^>]+)>/);

      if (match) {
        participants.add(match[1].trim());
      }
    }

    return Array.from(participants).sort();
  };

  useEffect(() => {
    if (url && fileName && fileType === "1") {
      toast.success("Uploaded!");
      setLoading(true);
      getParticipants({
        transcript_link: url,
        filename: fileName,
      })
        .then((res) => {
          // console.log(res.data.participants);
          // toast.success("Transcript Uploaded")
          setParticipants(JSON.parse(res.data.participants));
          setParticipant(JSON.parse(res.data.participants)[0]);
          setFileId(res.data.file_id);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Couldn't fetch participants from this transcript");
          setLoading(false);
        });
    }
    if (url && fileType === "2" && !transcriptLinkRec) {
      console.log("URL: ", url);
      console.log("Language: ", language);
      setLoading(true);
      toast.success("Uploaded!");
      getTranscription({
        audio_url: url,
        internal_language_code: language,
      })
        .then((res) => {
          // console.log("res - ", res);
          try {
            console.log(res, "get transcript link response");

            const transcription = res.transcriptions;
            const participants = extractParticipants(transcription);
            setTranscriptVtt(transcription);
            // Set participants and other necessary data
            console.log("Participant: ", participants);
            setParticipants(participants);
            setParticipant(participants[0]);
            // setFileId(res.data.file_id);
            setLoading(false);
          } catch (error) {
            toast.error("Couldn't perform transcription");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.info("Couldn't perform transcription");
          setLoading(false);
        });
    }
  }, [url, fileName]);

  const processTranscript = async () => {
    let reprocessData = false;
    userData?.meetings?.forEach((meeting) => {
      if (
        meeting.fileId === fileId &&
        meeting.participants.includes(participant) &&
        (meeting?.language ? meeting.language === language : true)
      ) {
        setReprocessCheck(true);
        reprocessData = true;
      }
    });
    if (!reprocessData) {
      localStorage.setItem(
        "bgProcessing",
        JSON.stringify({
          fileId: fileId,
          participant: participant,
          fileName:
            fileType === "1"
              ? fileName
              : fileName.replace("vtt", audioFileType), //fileName was changed to .vtt for getting Participants but now it has to be changed back to original name
          firebaseUrl: firebaseUrl, //contains the firebase url of audio/transcript
          url: url, //contains the url from getTranscriptLink if fileType==2 otherwise firebase url
          participants: participants,
          fileContent: fileContent,
          fileType: fileType,
          language: language,
          audioFileType: audioFileType,
          ftype: file?.type || "",
          audioDuration: audioDuration,
          transcriptVttFile: transcriptVtt,
        })
      );
    }
  };

  const fetchLanguages = async () => {
    if (userData) {
      const userSubscriptionData = userData.subscription || {};
      const languagesArray = userSubscriptionData?.[Object.keys(userSubscriptionData)[0]]?.languages || [];
      return languagesArray;
    } else {
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const languages = await fetchLanguages();
      setLanguagesArray(languages);
    };

    fetchData();
  }, []);
  let allowed_formats = ['avi', 'webm', 'mkv', 'flv', 'mov', 'wmv', '3gp', 'm4a', 'mp3',
                  'wav', 'ogg', 'flac', 'aac', 'wma', 'ac3', 'amr', 'm4b', 'opus', 'mp4'];
  return (
    <div className="xl:w-[48%] md:w-[80%] border-1 rounded-md max-w-[95%] w-[400px] box-border">
      <div className={`flex`}>
        <img src={logo} alt="" className="w-[400px]" />
      </div>
      <div className={`fade`}>
        {fileType === "2" && (
          <div className="fade">
            <div>
              <label className="text-[#474e4a]">Select language </label>
            </div>
            <div>
              <select
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                className='outline-0 px-[2%] py-[1%] text-[#474e4a] bg-[#F0F0F0] w-[100%] mb-[1%] appearance-none bg-[url("https://w7.pngwing.com/pngs/459/709/png-transparent-arrow-computer-icons-fleche-angle-text-rectangle.png")] bg-no-repeat bg-[length:0.7rem_0.7rem] bg-[center_right_1rem]'
              >
                {Object.entries(languageOptions).map(([value, optionText]) => (
                  <option
                    key={value}
                    value={value}
                    disabled={!languagesArray.includes(value)}
                  >
                    {optionText}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        <>
          <div className="text-[#474e4a]">Upload</div>
          <div className="flex justify-between rounded-[5px] w-[100%] px-[2%] py-[2%] bg-[#F0F0F0] items-center">
            <div className=" w-[50px]">
              <MdOutlineCloudUpload className="w-[35px] h-[35px] text-[#AEC2B6]" />
            </div>
            <div className=" w-[450px] pl-[15px]">
              <div className="text-[#474e4a]">
                {fileType === "1"
                  ? "Upload Your Transcript"
                  : "Upload Your Audio File"}
              </div>
              <div className="text-sm">
                {fileType === "1"
                  ? "Supports VTT, TXT, SRT"
                  : `Supports ${allowed_formats.map((r) => r.toUpperCase()).join(", ")} (Max 1GB)`}
              </div>
            </div>
            <div className="min-w-fit">
              <input
                type="file"
                placeholder="Browse files"
                ref={fileRef}
                className="hidden"
                id="selectedFile"
                onChange={(e) => {
                  let f = e.target.files[0];
                  let file_ext = f.name.split('.').pop().toLowerCase();
                  if(allowed_formats.indexOf(file_ext) > - 1){
                    setFile(f);
                  }else{
                    toast.error("Please select valid audio file.")
                  }
                }}
                accept={
                  fileType === "1"
                    ? ".vtt, .txt, .srt"
                    : "." + allowed_formats.join(", .")
                }
              />
              <div
                onClick={() => {
                  document.getElementById("selectedFile").click();
                }}
                className="text-[#474e4a] px-[10px] py-[5px] rounded-md border-2 border-gray-400 cursor-pointer w-fit"
              >
                Upload file
              </div>
            </div>
          </div>
        </>
        {percent !== 0 && percent !== 100 && (
          <div className="flex justify-between px-[2%] pt-[5px]">
            <Box sx={{ width: "100%" }}>
              <LinearProgressWithLabel
                color="primary"
                variant="determinate"
                value={percent}
              />
            </Box>
          </div>
        )}
        {file && (
          <div className="fade flex justify-between px-[2%] py-[3%]">
            <div className=" w-[30px]">
              <FaRegFile className="w-[25px] h-[25px] text-[#AEC2B6] " />
            </div>
            <div className=" w-[580px] text-[#474e4a]">{file?.name}</div>
            <div className=" w-[30px]  relative ">
              <RxCross2
                onClick={() => {
                  //we are reloading instead of setting all state values null because we also want to terminate all https callable function requests
                  window.location.reload();
                }}
                className="text-end cursor-pointer absolute right-[10px] w-[20px] h-[20px] font-bold "
              />
            </div>
          </div>
        )}
        {loading && (
          <>
            {/* <LinearProgress color='primary' /> */}
            <div
              className={`fade w-full flex flex-col items-center justify-center`}
            >
              <img src={cube} alt="" />
              <div className="text-xs">Fetching Participants...</div>
            </div>
          </>
        )}
        {audioNotAllowed && (
          <div className="text-sm flex items-center gap-[10px] fade">
            <MdError className="text-red-500" />
            Audio lengths more than 5 hours and size more than 1GB are not
            supported
          </div>
        )}
        {participants && (
          <div className="fade">
            <div className="text-[#474e4a] flex items-center justify-between">
              <div> Which participant are you? </div>
              <div
                onClick={() => {
                  setTranscriptModal(true);
                }}
                className="text-sm items-center cursor-pointer hover:text-black text-gray-500 transition flex gap-[5px]"
              >
                <FaEye /> View transcript
              </div>
            </div>
            <div className="">
              <select
                onChange={(e) => {
                  let newparticipant = e.target.value;
                  setParticipant(newparticipant);
                  console.log("new participant: ", e.target.value);
                  console.log("new participant: ", newparticipant);
                }}
                className='outline-0 px-[2%]  rounded-[5px] py-[1%]  bg-[#F0F0F0] w-[100%] mb-[1%] text-[#474e4a] appearance-none bg-[url("https://w7.pngwing.com/pngs/459/709/png-transparent-arrow-computer-icons-fleche-angle-text-rectangle.png")] bg-no-repeat bg-[length:0.7rem_0.7rem] bg-[center_right_1rem]'
              >
                {participants.map((p, idx) => {
                  return (
                    <option key={idx} value={p}>
                      {p}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        )}

        {participant && fileType === "1" && (
          <div className="fade">
            <div>
              <label className="text-[#474e4a]">Select language </label>
            </div>
            <div>
              <select
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                className='outline-0 px-[2%] py-[1%] text-[#474e4a] bg-[#F0F0F0] w-[100%] mb-[1%] appearance-none bg-[url("https://w7.pngwing.com/pngs/459/709/png-transparent-arrow-computer-icons-fleche-angle-text-rectangle.png")] bg-no-repeat bg-[length:0.7rem_0.7rem] bg-[center_right_1rem]'
              >
                <option value="english">English</option>
                <option value="arabic">Arabic</option>
                <option value="dutch">Dutch</option>
                <option value="french">French</option>
                <option value="german">German</option>
                <option value="hindi">Hindi</option>
                <option value="italian">Italian</option>
                <option value="japanese">Japanese</option>
                <option value="portuguese">Portuguese</option>
                <option value="spanish">Spanish</option>
                {/* <option value="multiLang">Multi Lingual (EN/AR/HI)</option> */}
                <option className="cursor-not-allowed" disabled value="tamil">
                  Tamil
                </option>
              </select>
            </div>
          </div>
        )}

        {reprocessCheck ? (
          <div className="flex items-center gap-[10px] fade">
            <div className="text-xs">
              File already processed, do you wish to process again?
            </div>
            <div
              onClick={() => {
                setReprocessCheck(false);
                //forceReprocess = true, that means it would skip to the else case where the api is hit again for reprocessing the data. Firebase won't be checked for any processed data
                localStorage.setItem(
                  "bgProcessing",
                  JSON.stringify({
                    fileId: fileId,
                    participant: participant,
                    fileName:
                      fileType === "1"
                        ? fileName
                        : fileName.replace("vtt", audioFileType),
                    firebaseUrl: firebaseUrl,
                    url: url,
                    participants: participants,
                    fileContent: fileContent,
                    fileType: fileType,
                    language: language,
                    audioFileType: audioFileType,
                    ftype: file?.type || "",
                    audioDuration: audioDuration,
                    forceReprocess: true,
                  })
                );
              }}
              className="rounded-md bg-[#2c74b3] text-white px-[20px] py-[6px] cursor-pointer"
            >
              Yes
            </div>
            <div
              onClick={() => {
                import("../../redux/actions/appActions").then((actions) =>
                  dispatch(
                    actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED)
                  )
                );
                navigate("/");
              }}
              className="rounded-md bg-[#144272] text-white px-[20px] py-[6px] cursor-pointer"
            >
              No
            </div>
          </div>
        ) : (
          fileId &&
          participant && (
            <div className="text-center">
              <button
                className={`${
                  dataLoading
                    ? "py-0 w-full"
                    : "py-[8px] border-[2px] px-[20px] fade rounded-[5px] text-[#474e4a]"
                } flex items-center justify-center`}
                onClick={() => {
                  import("../../redux/actions/appActions").then((actions) =>
                    dispatch(
                      actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSING)
                    )
                  );
                  if (localStorage.getItem("@auth")) {
                    processTranscript();
                  }
                }}
                disabled={dataLoading}
              >
                {dataLoading ? (
                  <div
                    className={`fade w-full flex flex-col items-center justify-center`}
                  >
                    <img src={cube} alt="" />
                    <div className="text-xs">Working our magic...</div>
                  </div>
                ) : (
                  "Process"
                )}
              </button>
            </div>
          )
        )}
      </div>
      {transcriptModal && (
        <TranscriptModal
          content={transcriptVtt}
          closeModal={() => {
            setTranscriptModal(false);
          }}
        />
      )}
      <img src={cube} alt="" className="h-0 w-0 overflow-hidden" />
      {dataLoading && !(fileId && participant) && (
        <div
          className={`fade w-full flex flex-col items-center justify-center`}
        >
          <img src={cube} alt="" />
          <div className="text-xs">
            Processing previous transcript, please wait...
          </div>
        </div>
      )}
    </div>
  );
};

export default Process;
